import { useState, useEffect } from "react";

const useUserData = () => {
  const [userData, setUserData] = useState(null);

  useEffect(() => {
    const localUser = localStorage.getItem("user_data");
    if (localUser) {
      try {
        setUserData(JSON.parse(localUser));
      } catch (error) {
        console.error("Error parsing user data:", error);
      }
    }
  }, []);

  return userData;
};

export default useUserData;
